import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import { languages } from "../../constants/languages";

class UpgradeAddressesContainer extends Component {
  state = {
    selectedYear: new Date().getFullYear(),
    loading: false,
  };

  handleYearChange = (event) => {
    this.setState({ selectedYear: event.target.value });
  };

  downloadAddresses = async () => {
    this.setState({ loading: true });
    const startDate = new Date(this.state.selectedYear, 0, 1);
    const endDate = new Date(this.state.selectedYear, 11, 31, 23, 59, 59);

    try {
      const snapshot = await window.firebase
        .firestore()
        .collection("upgrades")
        .where("timestamp", ">=", startDate)
        .where("timestamp", "<=", endDate)
        .where("payed", "==", true)
        .get();

      let addresses = [];
      snapshot.forEach((doc) => {
        const upgrade = doc.data();
        if (
          upgrade.address &&
          upgrade.zipCode &&
          upgrade.place &&
          upgrade.country
        ) {
          addresses.push({
            name: `${upgrade.firstName || ""} ${upgrade.lastName || ""}`.trim(),
            company: upgrade.companyName || "",
            address: `${upgrade.address}, ${upgrade.zipCode}, ${
              upgrade.place
            }, ${
              languages.countries[upgrade.country] || upgrade.country
            }`.trim(),
          });
        }
      });

      // Create CSV content
      const csvContent = ["Name,Company,Address"]
        .concat(
          addresses.map(
            (addr) => `"${addr.name}","${addr.company}","${addr.address}"`
          )
        )
        .join("\n");

      // Download file
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `upgrade_addresses_${this.state.selectedYear}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading addresses:", error);
    }

    this.setState({ loading: false });
  };

  render() {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

    return (
      <div style={{ padding: 20 }}>
        <h2>Download Upgrade Addresses</h2>
        <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
          <FormControl style={{ minWidth: 120 }}>
            <InputLabel>Year</InputLabel>
            <Select
              value={this.state.selectedYear}
              onChange={this.handleYearChange}
            >
              {years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            onClick={this.downloadAddresses}
            disabled={this.state.loading}
          >
            {this.state.loading ? "Downloading..." : "Download Addresses"}
          </Button>
        </div>
      </div>
    );
  }
}

export default UpgradeAddressesContainer;
